import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LiabilitiesDelagateConfirmationModel } from 'src/app/shared/models/liabilities-delagate-confirmation.model';

@Component({
standalone: false,
  selector: 'app-liability-delegate-confirmation-dialog',
  templateUrl: './liability-delegate-confirmation-dialog.component.html',
  styleUrls: ['./liability-delegate-confirmation-dialog.component.scss'],
})
export class LiabilityDelegateConfirmationDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: LiabilitiesDelagateConfirmationModel) {}
}
